// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2706":"d8523207","3091":"d8523207","5472":"d8523207","8153":"d8523207","8795":"d8523207"}[chunkId] + ".chunk.css";
};